export default function ServiceAutomation({ size = 96 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 96 96" fill="none" aria-hidden="true">
      <path
        d="M12 70 H30 L30 50 H50 L50 30 H68 L68 16"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <circle cx="12" cy="70" r="3" stroke="currentColor" strokeWidth="1.25" />
      <circle cx="30" cy="50" r="3" stroke="currentColor" strokeWidth="1.25" />
      <circle cx="50" cy="30" r="3" stroke="currentColor" strokeWidth="1.25" />
      <circle cx="68" cy="16" r="3" fill="#54B53C" />
      <path d="M76 50 H88 M82 44 V56" stroke="currentColor" strokeWidth="1.25" />
      <rect x="58" y="62" width="26" height="20" stroke="currentColor" strokeWidth="1.25" />
    </svg>
  );
}
